import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ModalData } from '../../models';
import { ModalBase } from '../modal-base.component';

@Component({
  selector: 'yes-no',
  templateUrl: './yes-no-modal.component.html',
  styleUrls: [
    '../../../../../../assets/styles/components/modal.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class YesNoModalComponent extends ModalBase {
  message: string;
  title: string;
  translateParams: object;

  constructor(protected dialogRef: MatDialogRef<YesNoModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string | { message: string, title: string } | ModalData) {
    super(data);
  }

  yes(): void {
    this.dialogRef.close(true);
  }

  no(): void {
    this.dialogRef.close(false);
  }
}
